import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.dashboard.summary');
import { OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { Service } from "src/libs/portal/season/service";
import { DashboardSummaryService, DashboardSummaryState } from 'src/app/dashboard-summary.service';

@Component({
    selector: 'wiz-component-dashboard-summary',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.dashboard.summary/view.scss */
:host {
  display: block;
}

.dashboard-summary-compact {
  border: 1px solid #d7dde5;
  border-radius: 7px;
  background: #fff;
  color: #172231;
}

.dashboard-summary-compact__heading {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #e4e8ed;
  padding: 13px 17px;
}

.dashboard-summary-compact h2 {
  margin: 0;
  font-size: 14px;
  font-weight: 800;
}

.dashboard-summary-compact__heading > span {
  color: #66717f;
  font-size: 10px;
  font-weight: 700;
}

.dashboard-summary-compact__grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.dashboard-summary-compact__card {
  min-width: 0;
  border-right: 1px solid #e4e8ed;
  background: #fff;
  padding: 15px 17px;
}

.dashboard-summary-compact__card:last-child {
  border-right: 0;
}

.dashboard-summary-compact__card > span,
.dashboard-summary-compact__card > strong {
  display: block;
}

.dashboard-summary-compact__card > span {
  color: #788390;
  font-size: 10px;
  font-weight: 600;
}

.dashboard-summary-compact__card > strong {
  margin-top: 5px;
  overflow: hidden;
  color: #172231;
  font-size: clamp(18px, 2vw, 24px);
  font-weight: 800;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dashboard-summary-compact__skeleton {
  height: 9px;
  border-radius: 3px;
  background: #e4e8ed;
  animation: dashboard-summary-pulse 1.3s ease-in-out infinite;
}

.dashboard-summary-compact__skeleton--label {
  width: 42%;
}

.dashboard-summary-compact__skeleton--value {
  width: 68%;
  height: 22px;
  margin-top: 7px;
}

.dashboard-summary-compact__error {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  padding: 13px 17px;
  color: #b42318;
  font-size: 11px;
}

.dashboard-summary-compact__error button {
  border: 1px solid #e4a7a2;
  border-radius: 4px;
  background: #fff;
  padding: 5px 8px;
  color: inherit;
  font-size: 10px;
  font-weight: 800;
}

.dashboard-summary-compact__error button:focus-visible {
  outline: 2px solid rgba(180, 35, 24, 0.24);
}

@keyframes dashboard-summary-pulse {
  50% {
    opacity: 0.45;
  }
}
@media (max-width: 840px) {
  .dashboard-summary-compact__grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .dashboard-summary-compact__card:nth-child(2) {
    border-right: 0;
  }
  .dashboard-summary-compact__card:nth-child(-n+2) {
    border-bottom: 1px solid #e4e8ed;
  }
}
@media (max-width: 420px) {
  .dashboard-summary-compact__grid {
    grid-template-columns: 1fr;
  }
  .dashboard-summary-compact__card,
  .dashboard-summary-compact__card:nth-child(2) {
    border-right: 0;
    border-bottom: 1px solid #e4e8ed;
  }
  .dashboard-summary-compact__card:last-child {
    border-bottom: 0;
  }
}`],
})
export class ComponentDashboardSummaryComponent implements OnInit {
    public readonly summaryState$: Observable<DashboardSummaryState>;

    constructor(@Inject( Service)         public service: Service,@Inject( DashboardSummaryService)         public dashboardSummary: DashboardSummaryService,    ) {
        this.summaryState$ = this.dashboardSummary.state$;
    }

    public async ngOnInit() {
        await this.service.init();
        await this.dashboardSummary.load();
    }

    public async retry() {
        await this.dashboardSummary.retry();
    }

    public formatCount(value: number | null | undefined): string {
        if (value === null || value === undefined) return '-';
        return Number(value).toLocaleString('ko-KR');
    }
}

export default ComponentDashboardSummaryComponent;